<script setup lang="ts">
interface IProps {
  isValid: boolean;
}

const props = defineProps<IProps>();
defineSlots<{ default: () => any }>();
</script>

<template>
  <span class="text-secondary flex items-center gap-2">
    <i
      v-if="!props.isValid"
      class="pi pi-times-circle text-red-500"
    />
    <i
      v-else
      class="pi pi-check-circle text-green-500"
    />
    <slot />
  </span>
</template>
